<template>
  <Catalogs
    title="Города"
    create-text="Новый"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'TownCatalogAdd'"
    :route-edit="'TownCatalogEdit'"
    :route-view="'TownCatalogView'"
    :route-path="'/town_catalogs'"
    :can-edit="canEditTownCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "TownCatalogs",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'towns-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Статус",
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'action',
          label: "Действия",
          class: 'towns-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getTowns(data);
    },
    canEditTownCatalogs() {
      return this.hasPermission([PERM.CATALOG_TOWN_EDIT]);
    }
  }
}
</script>

<style>
.towns-id {
  width: 60px;
  text-align: center;
}

.towns-action {
  width: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Towns/TownCatalogs.vue